import React from 'react';
import styles from './Checkout.module.scss'

const ErrorContainer = ({ errors }) => {
  return (
    <div className={styles.errorContainer}>
      <p>Please address the following errors:</p>

      <ul>
        {errors.map((error, i) => (
          <li key={i}>
            {error}
          </li>
        ))}
      </ul>
    </div>
  )
}

export default ErrorContainer;
